import { render } from "./SeoDetails.vue?vue&type=template&id=55a6d957&scoped=true"
import script from "./SeoDetails.vue?vue&type=script&lang=js"
export * from "./SeoDetails.vue?vue&type=script&lang=js"

import "./SeoDetails.vue?vue&type=style&index=0&id=55a6d957&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a6d957"]])

export default __exports__